// Core
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Custom layout
import MainLayout from '../../../Layouts/Main'

// style
import "./styles.scss"

//redux
import { useDispatch } from 'react-redux'
import { changePasswordRequest, logoutRequest } from '../../../Redux/Slices/authSlice'

// Custom components
import ErrorMessage from "Components/ErrorMessage";
import { notifySuccess } from 'Services/Utils/toastNotification'

const Settings = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [currentPasswordFocused, setCurrentPasswordFocused] = useState(false);
  const [newPasswordFocused, setNewPasswordFocused] = useState(false);
  const [confirmPasswordFocused, setConfirmPasswordFocused] = useState(false);

  const [errors, setErrors] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = (field) => {
    if (field === 'current') {
      setShowCurrentPassword(!showCurrentPassword);
    } else if (field === 'new') {
      setShowNewPassword(!showNewPassword);
    } else if (field === 'confirm') {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const validateForm = () => {
    const newErrors = {
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    };
    let isValid = true;

    if (!currentPassword) {
      newErrors.currentPassword = 'Current password is required';
      isValid = false;
    }

    if (!newPassword) {
      newErrors.newPassword = 'New password is required';
      isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirm password is required';
      isValid = false;
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const data = {
          "new_password": newPassword,
          "confirm_password": confirmPassword,
          "password": currentPassword
      }
      
      dispatch(
        changePasswordRequest({
          data,
          callBack: changePasswordCB
        })
      )
    }
  };

  const changePasswordCB = () => {
    notifySuccess("Password Changed successful!");
    dispatch(
      logoutRequest({
        callBack: logoutRequestCB,
      })
    );
  };

  const logoutRequestCB = () => {
    localStorage?.setItem("isLoggedIn", null);
    localStorage?.setItem("userDetails", null);
    navigate("/login");
  };

  return (
    <MainLayout pageName={"Settings"}>
      <div className="SettingsContainer"> 
        <div className="change-password-form">
          <h2>Change password</h2>
          <p>Provide current password and new password to update/change your password.</p>

          <div className={`input-container ${currentPasswordFocused ? 'focused' : ''}`}>
            <label className="floating-label">Current password</label>
            <div className="password-container">
              <input
                type={showCurrentPassword ? 'text' : 'password'}
                value={currentPassword}
                onChange={(e) => {setCurrentPassword(e.target.value);
                  setErrors({ ...errors, currentPassword: ''})
                }}
                onFocus={() => setCurrentPasswordFocused(true)}
                onBlur={(e) => setCurrentPasswordFocused(e.target.value !== '')}
              />
              <span className="toggle-icon" onClick={() => togglePasswordVisibility('current')}>
                {showCurrentPassword ? '👁️' : '👁️‍🗨️'}
              </span>
            </div>
            {errors.currentPassword && <ErrorMessage message={errors.currentPassword} />}
          </div>

          <div className={`input-container ${newPasswordFocused ? 'focused' : ''}`}>
            <label className="floating-label">New password</label>
            <div className="password-container">
              <input
                type={showNewPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => {setNewPassword(e.target.value);
                  setErrors({ ...errors, newPassword: ''})
                }}
                onFocus={() => setNewPasswordFocused(true)}
                onBlur={(e) => setNewPasswordFocused(e.target.value !== '')}
              />
              <span className="toggle-icon" onClick={() => togglePasswordVisibility('new')}>
                {showNewPassword ? '👁️' : '👁️‍🗨️'}
              </span>
            </div>
            {errors.newPassword && <ErrorMessage message={errors.newPassword} />}
          </div>

          <div className={`input-container ${confirmPasswordFocused ? 'focused' : ''}`}>
            <label className="floating-label">Confirm new password</label>
            <div className="password-container">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => {setConfirmPassword(e.target.value);
                  setErrors({ ...errors, confirmPassword: ''})
                }}
                onFocus={() => setConfirmPasswordFocused(true)}
                onBlur={(e) => setConfirmPasswordFocused(e.target.value !== '')}
              />
              <span className="toggle-icon" onClick={() => togglePasswordVisibility('confirm')}>
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </span>
            </div>
            {errors.confirmPassword && <ErrorMessage message={errors.confirmPassword} />}
          </div>

          <button className="submit-button" onClick={handleSubmit}>Update</button>
        </div>
      </div>
    </MainLayout>
  )
}

export default Settings;
